module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modals/warning-modal/warning-modal.component.scss
// module id = ./src/app/components/tools/modals/warning-modal/warning-modal.component.scss
// module chunks = main